import auth from 'src/helpers/auth';
import { getPublicInsightsParams } from '../apollo/helpers/insights';
import useGetInsights from '../apollo/query/insights/useGetInsights';
import { INSIGHT_STATUS_PUBLISHED } from '../constants/constants';

const PreloadData = () => {
    const isAdmin = auth().isAdmin();
    useGetInsights({
        params: getPublicInsightsParams(isAdmin),
        withTags: true,
        withAuthors: true,
        onError: () => null
    });
    useGetInsights({
        params: { limit: 3, requireImage: true, status: INSIGHT_STATUS_PUBLISHED, version: isAdmin },
        withTags: true,
        withAuthors: true,
        onError: () => null
    });
    return null;
};

export default PreloadData;
